import {
  EditSubscriptionUserRequest,
  UserRoleLightDto,
} from "@shared/types/common";

export default async (data?: object) => {
  const typedData = data as EditSubscriptionUserRequest;
  return {
    ...typedData,
    email: "john.doe@example.com",
    status: "INVITED",
    lastName: "Updated",
    firstName: "User",
  } satisfies UserRoleLightDto;
};
